import React, { useEffect, useState } from 'react'

import { cloneDeep } from 'lodash'

import { get } from 'services/api'
import { useDispatch, useSelector } from 'react-redux'
import { setFormOwner, setFormUUID } from 'redux/reducers/form'
import { getDataField } from 'utils/constants/dataFields'
import { ROUTE_CONSTANTS } from 'utils/constants/routeConstants'
import history from 'utils/history'
import { toast } from 'react-toastify'

import DesktopForm from './DesktopForm'
import MobileForm from './MobileForm'

const DueDiligence = () => {
  const token = useSelector((state) => state.auth.access_token)
  const dispatch = useDispatch()

  const [windowWidth, setWindowWidth] = useState(window.innerWidth)

  const initialValues = {
    address: {
      has_answer: false,
      answer: {},
    },
    social_networks: { has_answer: false, items: [] },
    financial_activities: { has_answer: false, items: [] },
    environment_related_activities: { has_answer: false, items: [] },
    external_activities: { has_answer: false, answer: {} },
    national_product_offering_activities: { has_answer: false, items: [] },
    international_product_offering_activities: {
      has_answer: false,
      items: [],
    },
    representation_activities: { has_answer: false, items: [] },
    automation_activities: { has_answer: false, items: [] },
    kinship_xp: { has_answer: false, items: [] },
    pep_relationship: { has_answer: false, items: [] },
    attorney_activities: { has_answer: false, items: [] },
    third_party_investments: { has_answer: false, investments_out_of_xp: {} },
    court_lawsuit_cvm_bacen_sfn: { has_answer: false, items: [] },
    environmental_court_lawsuit: { has_answer: false, items: [] },
    criminal_court_lawsuit: { has_answer: false, items: [] },
    negative_media: { has_answer: false, items: [] },
    restrictive_list: { has_answer: false, items: [] },
    relation_with_another_companies: { has_answer: false, items: [] },
    terms_agreement: { has_answer: false, answer: {} },
  }

  const [dueDiligence, setDueDiligence] = useState(initialValues)

  const handlePopulateForm = (formAnswers) => {
    const newFormData = cloneDeep(initialValues)
    formAnswers.forEach((answer) => {
      const answerObj = answer.answer_object
      newFormData[answerObj.question_name].answer_uuid = answer.uuid
      newFormData[answerObj.question_name].has_answer = true
      newFormData[answerObj.question_name][getDataField(answerObj.question_name)] =
        answerObj[getDataField(answerObj.question_name)]
    })
    setDueDiligence(newFormData)
  }

  const handleLoadForm = async () => {
    await get({ url: '/due_diligence/pf/form', token })
      .then((response) => {
        dispatch(setFormUUID(response?.data?.uuid))
        dispatch(setFormOwner(response?.data?.owner))
        
        if (response.data.filled) {
          history.push(ROUTE_CONSTANTS.DUE_DILIGENCE_RESUME)
          history.go(ROUTE_CONSTANTS.DUE_DILIGENCE_RESUME)
        }
        if (response.data.answers.length > 0)
          handlePopulateForm(response?.data?.answers)
      })
      .catch(async () => {
        toast.error('Algo deu errado, por favor tente novamente mais tarde.')
      })
  }

  useEffect(() => {
    handleLoadForm()
  }, [])

  useEffect(() => {
    const handleWindowResize = () => {
      setWindowWidth(window.innerWidth)
    }

    window.addEventListener('resize', handleWindowResize)

    return () => {
      window.removeEventListener('resize', handleWindowResize)
    }
  }, [])

  return windowWidth >= 1180 ? (
    <DesktopForm
      dueDiligence={dueDiligence}
      setDueDiligence={setDueDiligence}
    />
  ) : (
    <MobileForm dueDiligence={dueDiligence} setDueDiligence={setDueDiligence} />
  )
}

export default DueDiligence
